<div ng-init="mainPage()"></div>